import { FC, useMemo } from 'react';
import { Card } from "@/components/ui/card";
import { DollarSign, TrendingUp, TrendingDown } from 'lucide-react';

interface ExpenseStatsProps {
  expenses: Array<{
    amount: number;
    type: string;
  }>;
}

export const ExpenseStats: FC<ExpenseStatsProps> = ({ expenses }) => {
  const stats = useMemo(() => {
    const fixedExpenses = expenses
      .filter(e => e.type === 'fixed')
      .reduce((sum, e) => sum + Number(e.amount), 0);

    const variableExpenses = expenses
      .filter(e => e.type === 'variable')
      .reduce((sum, e) => sum + Number(e.amount), 0);

    const totalExpenses = fixedExpenses + variableExpenses;

    return {
      fixed: fixedExpenses,
      variable: variableExpenses,
      total: totalExpenses,
    };
  }, [expenses]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
      <Card className="p-4">
        <div className="flex items-center gap-2">
          <div className="p-2 bg-blue-100 rounded-lg">
            <TrendingDown className="h-5 w-5 text-blue-600" />
          </div>
          <div>
            <p className="text-sm font-medium text-gray-500">Fijos</p>
            <p className="text-2xl font-bold">${stats.fixed.toFixed(2)}</p>
          </div>
        </div>
      </Card>

      <Card className="p-4">
        <div className="flex items-center gap-2">
          <div className="p-2 bg-orange-100 rounded-lg">
            <TrendingUp className="h-5 w-5 text-orange-600" />
          </div>
          <div>
            <p className="text-sm font-medium text-gray-500">Variables</p>
            <p className="text-2xl font-bold">${stats.variable.toFixed(2)}</p>
          </div>
        </div>
      </Card>

      <Card className="p-4">
        <div className="flex items-center gap-2">
          <div className="p-2 bg-green-100 rounded-lg">
            <DollarSign className="h-5 w-5 text-green-600" />
          </div>
          <div>
            <p className="text-sm font-medium text-gray-500">Total</p>
            <p className="text-2xl font-bold">${stats.total.toFixed(2)}</p>
          </div>
        </div>
      </Card>
    </div>
  );
};